module.exports = __webpack_public_path__ + "img/RareCyte_Logo.d4328ba1.jpg";